import { useSyncExternalStore } from 'react';
import {
  subscribeToStaleBundle,
  isStaleBundle,
} from '@/lib/deploy-skew/stale-bundle';

/** Subscribes the dialog to the latch in `lib/deploy-skew/stale-bundle.ts`. */
export function useStaleBundle() {
  return useSyncExternalStore(
    subscribeToStaleBundle,
    isStaleBundle,
    () => false,
  );
}
